import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  EndIndividualUnpaidLeaveRequest,
  individualUnpaidLeavesService,
} from '@aslanpay/portal-common-lib';

const useEndUnpaidLeave = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, EndIndividualUnpaidLeaveRequest>) => {
  return useMutation<unknown, Error, EndIndividualUnpaidLeaveRequest>(
    ({ id }: EndIndividualUnpaidLeaveRequest) =>
      individualUnpaidLeavesService.endIndividualUnpaidLeave({
        id,
      }),
    { onSuccess, onError }
  );
};

export default useEndUnpaidLeave;
